export default __webpack_public_path__ + "static/media/300-400.6d838705.jpg";